enum Mutations {
  SET_USER_DETAILS = 'setUserDetails',
  SET_EMAIL_PENDING_VERIFICATION = 'setEmailPendingVerificationStatus',
  SET_SERVICE_REQUEST = 'setServiceRequest',
  SET_CONTRACT = 'setContract',
  SET_IS_PASSWORD_SET = 'setIsPasswordSet',
  SET_IS_ONE_TIME_LOGIN_SESSION = 'setIsOneTimeLoginSession',
}

export default Mutations
